/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import Helmet from "react-helmet"
import PropTypes from "prop-types"
import Header from "./header"
import Footer from "./footer"

const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        <script
          src="https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js"
          onLoad="loadCookieControl();"
        ></script>
        <script>
          {`
            /* Google Tag Manager / Google Analytics and Consent */
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}

            gtag('consent', 'default', {
              'ad_storage': 'denied',
              'analytics_storage': 'denied'
            });


            function loadCookieControl() {
              /* Civic cookies config */
              CookieControl.load({
                apiKey: window?.location.hostname === 'www.thediningoutgiftcard.co.uk' ? '8eced6e73ca70c74f723147dc3faed0d45b11c93' : '5018a65da7d94710b340175df0e17cce759bd8c3',
                product: window?.location.hostname === 'www.thediningoutgiftcard.co.uk' ? 'PRO' : 'PRO_MULTISITE',
                necessaryCookies: [],
                optionalCookies: [
                  {
                    name : 'analytics',
                    label: 'Analytical Cookies',
                    description: 'Analytical cookies help us to improve our website by collecting and reporting information on its usage.',
                    cookies: ['_ga', '_gid', '_gat', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv',
                                'dtCookie', 'dtLatC', 'dtPC', 'dtSa', 'dtValidationCookie', 'dtDisabled', 'rxVisitor', 'rxvt'],
                    onAccept : function(){
                      gtag('consent', 'update', {'analytics_storage': 'granted'});
                    },
                    onRevoke: function(){
                      gtag('consent', 'update', {'analytics_storage': 'denied'});
                    }
                  },
                  {
                    name: 'marketing',
                    label: 'Marketing',
                    description: 'We use marketing cookies to help us improve the relevancy of advertising campaigns you receive.',
                    onAccept: function(){
                      gtag('consent', 'update', {'ad_storage': 'granted'});
                    },
                    onRevoke: function(){
                      gtag('consent', 'update', {'ad_storage': 'denied'});
                    }
                  }
                ],
                mode: 'GDPR',
                consentCookieExpiry: 365,
                initialState: 'open',
                notifyOnce: false,
                rejectButton: true,
                layout: 'slideout',
                position: 'left',
                theme: 'light',
                toggleType: 'slider',
                settingsStyle: 'button',
                branding: {
                  fontFamily: "News Cycle, serif",
                  fontSizeTitle: "22px",
                  fontSizeHeaders: "22px",
                  fontSize: "18px",
                  acceptText: "#ffffff",
                  acceptBackground: "#002e5a",
                },
                text: {
                  accept: 'Allow All',
                  reject: 'Reject All',
                  settings: 'Manage Cookies',
                  title: 'Our Cookies',
                  intro: 'We use cookies and related technologies to understand and improve our systems and your experience, ' +
                  'including personalising content, adverts and social media features. You can find out more information in our ' +
                  '<a href="/cookies/">Cookie Policy</a> and our <a href="/privacy/">Privacy Policy</a>. Click "I Accept Cookies" to ' +
                  'agree to us using cookies and related technologies, "I Do Not Accept Cookies" to prevent this, or modify your preferences below.'
                },
                setInnerHTML: true,
              });
            }

            <!-- Google Tag Manager -->
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-PFLSNT');
            <!-- End Google Tag Manager -->
          `}
        </script>
      </Helmet>
      <Header />
      <div
        style={{
          margin: `0 auto`,
        }}
      >
        <main>{children}</main>
      </div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
